export default __webpack_public_path__ + "a3b8e7ff46bf0185ce11024011e734bc.png";